import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { Text } from '@marvelapp/ballpark-components';
import { Box, Flex, Loader } from '@marvelapp/ui';
export default observer(function ResultLoading({ size = 's', text = 'Still in progress', }) {
    return (_jsxs(Flex, { marginTop: "-1px", alignItems: "center", children: [_jsx(Box, { marginRight: "6px", children: _jsx(Loader, { speed: 1000, borderWidth: 3, size: 13 }) }), _jsx(Box, { paddingTop: "1px", children: _jsxs(Text, { size: size, children: [text, "..."] }) })] }));
});
